<div class="freebet-card__details-container">
    <ng-container *ngIf="!isRewardDrawerEnabled; then RewardToken; else rewardDrawerEnabled"></ng-container>

    <ng-template #RewardToken>
        <div class="reward-token-card__header-combined">
            <div class="reward-token-card__title reward-token-card__title-combined">{{ tokenTitle }}</div>
            <div class="freebet-card__right-column-container">
                <div class="freebet-card__value-container">
                    <div class="freebet-card__amount">
                        {{ token.amount | bsCurrency: prependCurrencySymbol : 2 : true : undefined : undefined : false }}
                    </div>
                    <div class="freebet-card__currency" *ngIf="!prependCurrencySymbol">{{ userService.currency }}</div>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #rewardDrawerEnabled>
        <div class="reward-token-card__header-combined">
            <ng-container [ngTemplateOutlet]="vipBadgeTemplate" />
            <div class="reward-token-card__title reward-token-card__title-combined">
                <span *ngIf="!isCustomTitle">{{ token.amount | bsCurrency: prependCurrencySymbol : 2 : true : undefined : undefined : false }} </span>
                <span class="freebet-card__currency" *ngIf="!prependCurrencySymbol && !isCustomTitle"> {{ userService.currency }} </span>
                <span class="reward-title">{{ tokenTitle }}</span>
            </div>
            <div class="freebet-card__currency" *ngIf="!prependCurrencySymbol">{{ userService.currency }}</div>
        </div>
    </ng-template>
    <div class="reward-token-card-category-link">
        <bs-reward-token-categories
            [categories]="tokenCategories"
            [isRewardDrawerEnabled]="isRewardDrawerEnabled"
            [tokenFilter]="token.filter"
            [betType]="betType.length > 0 ? betType[0].value : ''"></bs-reward-token-categories>
        <bs-reward-token-card-info-link
            *ngIf="termsAndConditionLinkText"
            [token]="token"
            [withArrow]="false"
            [overrideLinkTitleHtml]="termsAndConditionLinkText"></bs-reward-token-card-info-link>
    </div>
</div>
<div class="free-bet-card__link-group" *ngIf="tokenLimitations.length > 0">
    <bs-reward-token-limitations [limitations]="tokenLimitations" [isRewardDrawerEnabled]="isRewardDrawerEnabled"></bs-reward-token-limitations>
</div>
<div class="reward-token-card__payout-new-details" *ngIf="isRewardDrawerEnabled">
    <span class="reward-token-card__token-payout-title">{{ sitecore.crmTokens.cards.TokenPayout }}:&nbsp;</span
    ><span>{{ sitecore.crmTokens.cards.Winnings }} </span><span class="reward-token-card__token-payout-description">{{ payoutamountDetails }} </span>
</div>

<div [class.reward-token-footer-details]="applyRemoveButtonsShowHide()">
    <bs-reward-token-footer-details
        [expireTokenReward]="expireTokenReward"
        [token]="token"
        [promoHubUrlTokenType]="promoHubUrlTokenType"
        [tokenTitle]="tokenTitle"
        [tokenCategories]="tokenCategories"
        [isRewardBannerView]="isRewardBannerView"></bs-reward-token-footer-details>
    @if (applyRemoveButtonsShowHide()) {
        <button ds-button size="small" variant="outline" kind="secondary">
            {{ applyOrRemoveTokenText }}
        </button>
    }
</div>
